import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default function NominationDashboard() {
  const forms = [
    {
      to: "/mock-ssce-examiner",
      title: "MOCK SSCE – Examiner Nomination",
      emoji: "📝",
      color: "text-blue-600",
    },
    {
      to: "/mock-ssce-supervisor",
      title: "MOCK SSCE – Supervisor Nomination",
      emoji: "🧑‍🏫",
      color: "text-green-600",
    },
    {
      to: "/bece-examiner",
      title: "BECE – Examiner Nomination",
      emoji: "📘",
      color: "text-blue-600",
    },
    {
      to: "/bece-supervisor",
      title: "BECE – Supervisor Nomination",
      emoji: "🎓",
      color: "text-green-600",
    },
  ];

  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto p-8">
        {/* Header */}
        <h1 className="text-4xl font-extrabold mb-10 text-center text-brand-900">
          Nomination Portal
        </h1>

        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Select the appropriate nomination form for your school. Ensure all
          information is entered accurately before submission.
        </p>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {forms.map((form) => (
            <Link
              key={form.to}
              to={form.to}
              aria-label={form.title}
              className="group p-8 bg-white border border-gray-200 rounded-2xl shadow-md 
                       hover:shadow-xl transition-all hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              <div
                className={`${form.color} text-5xl mb-4 text-center group-hover:scale-110 transition-transform`}
              >
                {form.emoji}
              </div>
              <h3 className="text-lg text-center font-semibold text-gray-800">
                {form.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
      {/* <Contact /> */}
      <Footer />
    </>
  );
}
